import { Box, Typography } from "@mui/material";
import { useContext, useState } from "react";
import { DatePicker } from "@mui/x-date-pickers";
import { Errors, PlanDetailsForm } from "../nux/member/types";
import { CurrentUserContext } from "../context/RequireAuth";
import { hasRole, ROLE_ADMIN } from "../../common/userUtils";
import ProductSelect from "./ProductSelect";
import CouponSelect from "./CouponSelect";

export default ({
  planDetails,
  errors,
  onPlanDetailsChange,
  disabled = false,
  stacked = false,
  initialProductName,
  initialCouponId,
}: {
  planDetails: PlanDetailsForm;
  errors: Errors;
  onPlanDetailsChange: (planDetails: Partial<PlanDetailsForm>) => void;
  disabled?: boolean;
  stacked: boolean;
  initialProductName?: string;
  initialCouponId?: string;
}) => {
  const currentUser = useContext(CurrentUserContext);
  const isAdmin = hasRole(currentUser, ROLE_ADMIN);
  const widthPercentage = isAdmin ? 33 : 50;
  const [dateOpen, setDateOpen] = useState(false);
  return (
    <Box display="flex" flexDirection="column" gap="12px">
      <Box sx={{ marginBottom: "4px" }}>
        <Typography variant="bodyHeavy">Plan details</Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: "12px",
          flexDirection: stacked ? "column" : "row",
        }}
      >
        <DatePicker
          sx={{
            width: stacked ? "100%" : `calc(${widthPercentage}% - 8px)`,
            ".MuiButtonBase-root": { marginRight: "unset" },
          }}
          label="Starting date"
          defaultValue={planDetails.startDate}
          disabled={disabled}
          onChange={(date) => {
            if (date === null) return;
            onPlanDetailsChange({ startDate: date });
          }}
          format="MM/dd/yyyy"
          open={dateOpen}
          onClose={() => setDateOpen(false)}
          slotProps={{
            textField: {
              error: !!errors.startDate,
              helperText: errors.startDate,
              onClick: () => !disabled && setDateOpen(true),
            },
          }}
        />
        <ProductSelect
          disabled={disabled}
          stacked={stacked}
          value={planDetails.product}
          onUpdate={(product) => {
            onPlanDetailsChange({ product: product });
          }}
          isAdmin={isAdmin}
          widthPercentage={widthPercentage}
          initialProductName={initialProductName}
        />
        <CouponSelect
          disabled={disabled}
          stacked={stacked}
          value={planDetails.coupon}
          onUpdate={(coupon) => {
            onPlanDetailsChange({ coupon: coupon });
          }}
          isAdmin={isAdmin}
          widthPercentage={widthPercentage}
          initialCouponId={initialCouponId}
        />
      </Box>
    </Box>
  );
};
